import React from 'react';

const DistributionSvg = () => (
  <svg
    viewBox="0 0 347 307"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs>
      <linearGradient
        x1="82.0681551%"
        y1="75.6832821%"
        x2="33.0100248%"
        y2="41.0490889%"
        id="linearGradient-1"
      >
        <stop stopColor="#292F36" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="87.8972921%"
        y1="50%"
        x2="12.9291239%"
        y2="50%"
        id="linearGradient-2"
      >
        <stop stopColor="#292F36" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="82.0681551%"
        y1="75.6355802%"
        x2="33.0100248%"
        y2="41.0657135%"
        id="linearGradient-3"
      >
        <stop stopColor="#292F36" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <filter
        x="-100.3%"
        y="-100.1%"
        width="300.6%"
        height="300.3%"
        filterUnits="objectBoundingBox"
        id="filter-4"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="13"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <polygon
        id="path-5"
        points="7.5495574e-05 0.125858637 35.8079531 0.125858637 35.8079531 35.7188816 7.5495574e-05 35.7188816"
      />
      <linearGradient
        x1="50%"
        y1="68.0106633%"
        x2="50%"
        y2="10.2457429%"
        id="linearGradient-7"
      >
        <stop stopColor="#292F36" offset="0%" />
        <stop stopColor="#FFFFFF" offset="100%" />
      </linearGradient>
      <filter
        x="-134.8%"
        y="-134.6%"
        width="369.6%"
        height="369.1%"
        filterUnits="objectBoundingBox"
        id="filter-8"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="13"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <polygon
        id="path-9"
        points="0.0001252 0.54277377 20.092096 0.54277377 20.092096 20.0724783 0.0001252 20.0724783"
      />
      <polygon
        id="path-11"
        points="0.0562076943 0.500761475 5.04008409 0.500761475 5.04008409 10.0327869 0.0562076943 10.0327869"
      />
      <filter
        x="-81.4%"
        y="-81.2%"
        width="262.8%"
        height="263.3%"
        filterUnits="objectBoundingBox"
        id="filter-13"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="13"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter
        x="-14.7%"
        y="-14.6%"
        width="129.3%"
        height="129.5%"
        filterUnits="objectBoundingBox"
        id="filter-14"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="4"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.160784314   0 0 0 0 0.184313725   0 0 0 0 0.211764706  0 0 0 0.1 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <linearGradient
        x1="50.000006%"
        y1="-4.73717682%"
        x2="50.000006%"
        y2="137.629562%"
        id="linearGradient-15"
      >
        <stop stopColor="#AE4EFF" offset="0%" />
        <stop stopColor="#8940FA" offset="44.5222909%" />
        <stop stopColor="#893FFA" offset="65.9737723%" />
        <stop stopColor="#8E47FA" offset="100%" />
      </linearGradient>
      <filter
        x="-102.7%"
        y="-102.5%"
        width="306.2%"
        height="305.7%"
        filterUnits="objectBoundingBox"
        id="filter-16"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="13"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter
        x="-134.8%"
        y="-134.6%"
        width="371.9%"
        height="371.3%"
        filterUnits="objectBoundingBox"
        id="filter-17"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="13"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g
      id="Home-Page"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Anchor-HP---desktop---dark-v1"
        transform="translate(-695.000000, -1235.000000)"
      >
        <g id="Features" transform="translate(-11.000000, 597.000000)">
          <g
            id="100%-free-hosting"
            transform="translate(235.000000, 646.000000)"
          >
            <g id="distribution2" transform="translate(488.000000, 0.000000)">
              <g id="Group-8" transform="translate(7.512000, 14.422131)">
                <path
                  d="M219.20672,95.9385246 L259.164,152.045944 L255.681388,156.135246 L195.312,122.723125 C201.91052,120.876984 208.06422,119.421572 212.879121,113.767352 C217.758033,108.038139 218.39628,102.935994 219.20672,95.9385246 Z"
                  id="Fill-39"
                  fillOpacity="0.4"
                  fill="url(#linearGradient-1)"
                  opacity="0.7"
                  transform="translate(227.238000, 126.036885) scale(-1, 1) translate(-227.238000, -126.036885) "
                />
                <g id="Group" transform="translate(0.000000, 0.627049)">
                  <path
                    d="M25.0706863,180.941554 C25.0706863,180.941554 31.0134035,189.397978 31.0134035,196.647504 C31.0134035,204.019083 28.8242693,208.231278 25.0706863,213.960086 L97.6437255,200.256323 L97.6437255,194.862887 C49.2616993,185.581998 25.0706863,180.941554 25.0706863,180.941554 Z"
                    id="Fill-1"
                    fillOpacity="0.3"
                    fill="url(#linearGradient-2)"
                  />
                  <path
                    d="M196.606961,180.941554 C196.606961,180.941554 202.549678,189.397978 202.549678,196.647504 C202.549678,204.019083 200.360544,208.231278 196.606961,213.960086 L269.18,200.256323 L269.18,194.862887 C220.797974,185.581998 196.606961,180.941554 196.606961,180.941554 Z"
                    id="Fill-1"
                    fillOpacity="0.3"
                    fill="url(#linearGradient-2)"
                    transform="translate(232.893480, 197.450820) scale(-1, 1) translate(-232.893480, -197.450820) "
                  />
                  <path
                    d="M58.0584314,98.1353087 L97.7756759,153.853858 L94.3139847,157.914817 L34.3072549,124.73427 C40.8661353,122.900924 46.9828682,121.4556 51.768845,115.840568 C56.6184479,110.151063 57.2528602,105.08428 58.0584314,98.1353087 Z"
                    id="Fill-39"
                    fillOpacity="0.4"
                    fill="url(#linearGradient-3)"
                    opacity="0.7"
                  />
                  <g
                    id="Group-5"
                    filter="url(#filter-4)"
                    transform="translate(11.875588, 79.244476)"
                  >
                    <ellipse
                      id="Oval"
                      fill="#F24336"
                      fillRule="nonzero"
                      cx="26.3901961"
                      cy="26.4148254"
                      rx="26.3901961"
                      ry="26.4148254"
                    />
                    <g id="Group-6" transform="translate(8.444863, 8.452744)">
                      <g id="Group-3" transform="translate(0.000000, 0.079444)">
                        <mask id="mask-6" fill="white">
                          <use xlinkHref="#path-5" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M33.3617979,18.0124777 C31.1056364,18.0225365 31.1056364,18.0225365 30.7312596,15.8794036 C29.5881212,9.33648456 24.2008084,4.92314987 17.4927603,5.03461741 C11.2968761,5.13746316 5.95329214,9.93036228 5.02570405,16.2170907 C3.96362909,23.4167034 9.46026406,30.2843769 16.7644273,30.8222129 C17.6895401,30.8903662 18.0655671,31.1732433 17.9964672,32.1091191 C17.9337617,32.9598033 17.94325,33.8209568 17.9929607,34.6732832 C18.0401961,35.4806531 17.7464702,35.7618879 16.9222224,35.7138522 C11.6048345,35.4026463 7.25484448,33.1578994 3.94506495,29.0674716 C-4.34877307,18.8177948 1.11341511,3.40550797 13.9983707,0.560519576 C24.7878477,-1.82156032 35.0319515,5.86169428 35.8005068,16.8908227 C35.8615622,17.7673723 35.5521599,18.0898686 34.7017161,18.0188414 C34.2580332,17.9818909 33.8085748,18.0124777 33.3617979,18.0124777"
                          id="Fill-1"
                          fill="#FFFFFF"
                          mask="url(#mask-6)"
                        />
                      </g>
                      <path
                        d="M26.1587268,18.0953291 C25.9184243,18.094508 25.6731714,18.0641264 25.4384382,18.0998453 C24.5085812,18.242105 24.1989726,17.7976718 24.0545849,16.9262542 C23.5413896,13.8279492 20.6546661,11.5637005 17.5946774,11.7769874 C14.271903,12.0087496 11.8251496,14.5086607 11.6421897,17.8596666 C11.4784128,20.8547153 13.762008,23.6736331 16.8525244,24.1513218 C17.7875382,24.2958396 18.0767262,24.6836152 17.9931876,25.5550328 C17.9379077,26.1310511 17.9399704,26.7195915 17.9890622,27.2964309 C18.0678566,28.2259429 17.5878705,28.4295816 16.7947693,28.3119556 C12.8185372,27.7223888 9.86622051,25.6958555 8.34251732,21.9638482 C6.72537464,18.0027474 7.35985562,14.2656081 10.251942,11.0960706 C13.1155634,7.95794101 16.7805368,6.94960109 20.8473206,8.14659418 C25.0036248,9.36986323 27.4314015,12.2975798 28.2028446,16.5468951 C28.4714058,18.025123 28.3530079,18.0967661 26.1587268,18.0953291"
                        id="Fill-4"
                        fill="#FFFFFF"
                      />
                    </g>
                  </g>
                  <path
                    d="M121.394902,50.1881682 L138.383321,170.375624 L143.678637,170.375624 L162.299706,50.3009078 C156.522801,54.3825197 149.503052,56.7817938 141.926129,56.7817938 C134.281179,56.7817938 127.203121,54.3365482 121.394902,50.1881682 Z"
                    id="Fill-23"
                    fillOpacity="0.4"
                    fill="url(#linearGradient-7)"
                    opacity="0.7"
                  />
                  <g
                    id="Group-2"
                    filter="url(#filter-8)"
                    transform="translate(0.000000, 176.979330)"
                  >
                    <path
                      d="M39.5852941,19.811119 C39.5852941,30.752697 30.7234243,39.6222381 19.7920482,39.6222381 C8.86067221,39.6222381 0,30.752697 0,19.811119 C0,8.86954102 8.86067221,0 19.7920482,0 C30.7234243,0 39.5852941,8.86954102 39.5852941,19.811119 Z"
                      id="Stroke-25"
                      fill="#D34CEF"
                    />
                    <g id="Group-11" transform="translate(10.016000, 8.627227)">
                      <g id="Group-3" transform="translate(0.000000, 0.711701)">
                        <mask id="mask-10" fill="white">
                          <use xlinkHref="#path-9" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M6.4779732,20.0139049 C2.5967732,18.5378311 0.0001252,14.7730279 0.0001252,10.605659 C0.0001252,5.05627377 4.5060732,0.54277377 10.0461732,0.54277377 C15.5837692,0.54277377 20.0922212,5.05627377 20.0922212,10.605659 C20.0922212,14.7542164 17.5181092,18.522782 13.6581932,20.0076344 C13.6256412,20.0201754 13.3214052,20.1342984 13.2112292,20.0239377 C13.0998012,19.912323 13.2976172,18.7322164 13.3990292,18.688323 C16.6316932,17.3401672 18.7826292,14.1334377 18.7826292,10.605659 C18.7826292,5.77988852 14.8626172,1.85456066 10.0461732,1.85456066 C5.2284772,1.85456066 1.3097172,5.77988852 1.3097172,10.605659 C1.3097172,14.1384541 3.4556452,17.337659 6.6895612,18.6870689 C6.8072492,18.7359787 6.9825292,19.9725197 6.8610852,20.0440033 C6.7396412,20.116741 6.5180372,20.0289541 6.4779732,20.0139049"
                          id="Fill-1"
                          fill="#FFFFFF"
                          mask="url(#mask-10)"
                        />
                      </g>
                      <path
                        d="M13.7026392,16.8972197 C13.4860432,16.7555066 13.5786912,15.460023 13.6750952,15.3734902 C14.8444632,14.338859 15.5180392,12.8941377 15.5180392,11.3177361 C15.5180392,8.29535902 13.0628672,5.83607213 10.0455472,5.83607213 C7.0282272,5.83607213 4.5730552,8.29535902 4.5730552,11.3177361 C4.5730552,12.9041705 5.2341112,14.3714656 6.4047312,15.4111131 C6.5236712,15.5164574 6.5274272,16.6915475 6.4047312,16.8545803 C6.3045712,16.9850066 5.9377352,16.7454738 5.9151992,16.7279164 C4.2412752,15.4462279 3.2446832,13.4283836 3.2446832,11.3177361 C3.2446832,7.56171148 6.2958072,4.50547377 10.0455472,4.50547377 C13.7952872,4.50547377 16.8464112,7.56171148 16.8464112,11.3177361 C16.8464112,13.2327443 16.0313592,15.0599656 14.6341272,16.3441623 C14.4425712,16.5197361 13.8328472,16.9824984 13.7026392,16.8972197"
                        id="Fill-4"
                        fill="#FFFFFF"
                      />
                      <path
                        d="M12.4030632,10.4748566 C12.4030632,11.7640697 11.3576432,12.8112418 10.0705872,12.8112418 C8.7810272,12.8112418 7.7368592,11.7640697 7.7368592,10.4748566 C7.7368592,9.18438934 8.7810272,8.13847131 10.0705872,8.13847131 C11.3576432,8.13847131 12.4030632,9.18438934 12.4030632,10.4748566"
                        id="Fill-6"
                        fill="#FFFFFF"
                      />
                      <g
                        id="Group-10"
                        transform="translate(7.512000, 13.252684)"
                      >
                        <mask id="mask-12" fill="white">
                          <use xlinkHref="#path-11" />
                        </mask>
                        <g id="Clip-9" />
                        <path
                          d="M2.519024,0.500761475 C1.105516,0.500761475 0.042568,1.10649098 0.05634,2.38817951 C0.070112,3.66861393 0.299228,5.78553197 0.487028,7.32180246 C0.674828,8.85932705 0.903944,10.0331631 2.47896,10.0331631 C4.053976,10.0331631 4.268068,9.26440082 4.552272,7.24154016 C4.835224,5.21993361 4.937888,4.23546639 5.036796,2.48223689 C5.116924,1.05256475 3.717188,0.500761475 2.519024,0.500761475"
                          id="Fill-8"
                          fill="#FFFFFF"
                          mask="url(#mask-12)"
                        />
                      </g>
                    </g>
                  </g>
                  <g
                    id="Group-7"
                    filter="url(#filter-13)"
                    transform="translate(109.519314, 0.000000)"
                  >
                    <path
                      d="M65.9754902,33.0190312 C65.9754902,51.2537197 51.2057071,66.0370634 32.9867471,66.0370634 C14.767787,66.0370634 0,51.2537197 0,33.0190312 C0,14.7833437 14.767787,0 32.9867471,0 C51.2057071,0 65.9754902,14.7833437 65.9754902,33.0190312 Z"
                      id="Stroke-31"
                      fill="#1ED760"
                    />
                    <path
                      d="M43.2085625,30.5484262 C37.1635111,26.9477526 27.1923338,26.616682 21.4216096,28.3733328 C20.4947196,28.6554391 19.5147557,28.1307573 19.2339343,27.2013339 C18.9531128,26.2712366 19.4757901,25.2890305 20.4031279,25.006475 C27.0275135,22.9897295 38.0397905,23.3791979 44.9989672,27.5225218 C45.832474,28.018903 46.1059054,29.0985885 45.6118925,29.9332278 C45.1174318,30.7692148 44.0400538,31.0448075 43.2085625,30.5484262 Z M43.3270207,35.8285491 C42.9167455,36.594465 42.0463729,36.8347327 41.3815711,36.364416 C36.5065746,32.9166732 29.072882,31.9177175 23.3054178,33.9320787 C22.5574346,34.1920365 21.767644,33.7070146 21.5404113,32.8478828 C21.3151282,31.9875048 21.7368842,31.0802697 22.4835677,30.8185672 C29.0720155,28.5180781 37.2625728,29.6321828 42.8617244,33.591367 C43.5265262,34.0624314 43.7357796,35.064378 43.3270207,35.8285491 Z M42.2029639,41.7778163 C41.8650503,42.405495 41.1436441,42.6020897 40.5915314,42.2195821 C36.1762018,39.1628274 30.6187017,38.4725843 24.0737306,40.1658926 C23.4430334,40.3296791 22.8143569,39.8820638 22.6704349,39.1676596 C22.5260638,38.4535098 22.9198847,37.7413945 23.5519291,37.578371 C30.7143504,35.7238195 36.8580912,36.5218972 41.8140826,39.952258 C42.3666443,40.3345113 42.540653,41.1521722 42.2029639,41.7778163 Z M32.5079234,14.528154 C22.5707006,14.528154 14.5146078,22.5915501 14.5146078,32.5380471 C14.5146078,42.4856194 22.5707006,50.5483704 32.5079234,50.5483704 C42.4455759,50.5483704 50.5012389,42.4856194 50.5012389,32.5380471 C50.5012389,22.5915501 42.4455759,14.528154 32.5079234,14.528154 L32.5079234,14.528154 Z"
                      id="Spotify_Icon_RGB_White"
                      fill="#FFFFFE"
                    />
                  </g>
                  <g
                    id="logo"
                    filter="url(#filter-14)"
                    transform="translate(76.531569, 137.357092)"
                  >
                    <rect
                      id="Background"
                      fill="url(#linearGradient-15)"
                      x="0"
                      y="0"
                      width="135.90951"
                      height="136.036351"
                      rx="19"
                    />
                    <path
                      d="M70.2983575,71.3484227 L43.1082481,71.3484227 C41.8957721,73.7775771 39.3668887,75.4521446 36.4505743,75.4521446 C32.3584917,75.4521446 29.0292157,72.1551157 29.0292157,68.1026686 C29.0292157,64.0502215 32.3584917,60.7540984 36.4505743,60.7540984 C39.3102021,60.7540984 41.7973142,62.3637566 43.0360569,64.7163213 L70.4638086,64.7163222 C69.6439212,60.8438715 67.3701769,57.53044 64.2907465,55.83817 L62.0169608,54.5891032 L66.1630069,47.5466857 L68.3434998,48.7513693 C71.4523484,50.4687228 74.0883301,53.1253673 75.9660783,56.4341713 C77.8612047,59.7746776 78.8993168,63.6495923 78.9679145,67.6395408 L78.9688292,67.6830181 L78.9679145,67.7255896 C78.8993168,71.7155381 77.8612047,75.5913586 75.9660783,78.9318649 C74.0883301,82.2406689 71.4523484,84.8973133 68.3434998,86.6137611 L66.1630069,87.8184447 L62.0169608,80.7760272 L64.2907465,79.5269605 C67.1830238,77.9375385 69.3645706,74.9180201 70.2983575,71.3484227 Z M34.3072549,68.2127402 C34.3072549,69.412895 35.2923182,70.388417 36.5042112,70.388417 C37.7161042,70.388417 38.7011675,69.412895 38.7011675,68.2127402 C38.7011675,67.0134912 37.7161042,66.0370634 36.5042112,66.0370634 C35.2923182,66.0370634 34.3072549,67.0134912 34.3072549,68.2127402 Z M98.1142404,72.2522308 L98.2349724,68.0177224 L98.1142404,63.7841199 C96.5730783,48.7083646 88.1931809,36.0057455 76.5315686,29.7567887 L80.94103,22.4526016 C96.0645405,30.6000673 106.610297,47.8940709 106.964261,68.0177224 C106.610297,88.1431855 96.0645405,105.437189 80.94103,113.583749 L76.5315686,106.279562 C88.1931809,100.030605 96.5739929,87.3288919 98.1142404,72.2522308 Z M72.8099463,100.711907 L68.6145098,93.5852523 L69.6910367,92.9928741 C73.4181794,90.9458177 76.6751991,87.8054882 79.1090462,83.9133637 C81.5931983,79.9415307 83.165458,75.2640974 83.658447,70.38377 L83.7380203,67.5251372 L83.658447,64.6674102 C83.165458,59.786177 81.5931983,55.1096494 79.1090462,51.1378165 C76.6742845,47.2447862 73.4181794,44.1053625 69.6910367,42.0574003 L68.6145098,41.4659278 L72.8099463,34.339273 L73.8434853,34.9099126 C79.1300829,37.8301382 83.6264347,42.371705 86.8432104,48.0418701 C90.1294985,53.8334094 91.9295026,60.5633338 92.0484053,67.5052101 L92.04932,67.5251372 L92.0484053,67.5459701 C91.9295026,74.4878464 90.1294985,81.2177708 86.8432104,87.00931 C83.6264347,92.6794752 79.1300829,97.2210419 73.8434853,100.141268 L72.8099463,100.711907 Z"
                      id="Combined-Shape"
                      stroke="#FFFFFF"
                      strokeWidth="0.5"
                      fill="#FFFFFF"
                    />
                  </g>
                </g>
                <g
                  id="google_podcasts_icon_badge_svg"
                  filter="url(#filter-16)"
                  transform="translate(224.108000, 80.889344)"
                >
                  <g id="logo_google_search_round_48dp">
                    <polygon
                      id="Shape"
                      points="0 0 52.584 0 52.584 52.6721311 0 52.6721311"
                    />
                    <ellipse
                      id="Oval"
                      fill="#FFFFFF"
                      fillRule="nonzero"
                      cx="26.292"
                      cy="26.3360656"
                      rx="25.4252307"
                      ry="25.4678436"
                    />
                  </g>
                  <g
                    id="_logo_Podcasts_192px"
                    transform="translate(8.620328, 8.634776)"
                    fillRule="nonzero"
                  >
                    <polygon
                      id="Shape"
                      fill="#FAB908"
                      points="15.1742444 11.0543102 15.1742444 16.3189254 15.1742444 18.4231924 15.1742444 23.6878076 19.5097428 23.6878076 19.5097428 18.4231924 19.5097428 16.3189254 19.5097428 11.0543102"
                    />
                    <ellipse
                      id="Oval"
                      fill="#0066D9"
                      cx="2.1677492"
                      cy="16.1866686"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <ellipse
                      id="Oval"
                      fill="#0066D9"
                      cx="2.1677492"
                      cy="18.5554493"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <polygon
                      id="Rectangle-path"
                      fill="#0066D9"
                      points="0 16.1866686 4.3354984 16.1866686 4.3354984 18.5554493 0 18.5554493"
                    />
                    <ellipse
                      id="Oval"
                      fill="#4285F4"
                      cx="32.516238"
                      cy="18.5554493"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <ellipse
                      id="Oval"
                      fill="#4285F4"
                      cx="32.516238"
                      cy="16.1866686"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <polygon
                      id="Rectangle-path"
                      fill="#4285F4"
                      transform="translate(32.516239, 17.371059) rotate(180.000000) translate(-32.516239, -17.371059) "
                      points="30.3484896 16.1866683 34.683988 16.1866683 34.683988 18.5554491 30.3484896 18.5554491"
                    />
                    <ellipse
                      id="Oval"
                      fill="#EA4335"
                      cx="9.65633731"
                      cy="23.2930108"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <ellipse
                      id="Oval"
                      fill="#EA4335"
                      cx="9.65633731"
                      cy="25.6617916"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <polygon
                      id="Rectangle-path"
                      fill="#EA4335"
                      points="7.48858815 23.2930108 11.8240865 23.2930108 11.8240865 25.6617916 7.48858815 25.6617916"
                    />
                    <ellipse
                      id="Oval"
                      fill="#EA4335"
                      cx="9.65633731"
                      cy="9.08032622"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <ellipse
                      id="Oval"
                      fill="#EA4335"
                      cx="9.65633731"
                      cy="16.7788637"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <polygon
                      id="Rectangle-path"
                      fill="#EA4335"
                      points="7.48858815 9.08032622 11.8240865 9.08032622 11.8240865 16.8282133 7.48858815 16.8282133"
                    />
                    <ellipse
                      id="Oval"
                      fill="#34A853"
                      cx="25.0276498"
                      cy="11.449107"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <ellipse
                      id="Oval"
                      fill="#34A853"
                      cx="25.0276498"
                      cy="9.08032622"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <rect
                      id="Rectangle-path"
                      fill="#34A853"
                      transform="translate(25.027649, 10.264716) rotate(180.000000) translate(-25.027649, -10.264716) "
                      x="22.8598999"
                      y="9.0803255"
                      width="4.3354984"
                      height="2.36878076"
                    />
                    <ellipse
                      id="Oval"
                      fill="#FAB908"
                      cx="17.3419936"
                      cy="4.54016312"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <ellipse
                      id="Oval"
                      fill="#FAB908"
                      cx="17.3419936"
                      cy="2.17138237"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <rect
                      id="Rectangle-path"
                      fill="#FAB908"
                      transform="translate(17.341993, 3.355773) rotate(180.000000) translate(-17.341993, -3.355773) "
                      x="15.1742442"
                      y="2.17138223"
                      width="4.3354984"
                      height="2.36878076"
                    />
                    <ellipse
                      id="Oval"
                      fill="#FAB908"
                      cx="17.3419936"
                      cy="32.5707355"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <ellipse
                      id="Oval"
                      fill="#FAB908"
                      cx="17.3419936"
                      cy="30.2019547"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <polygon
                      id="Rectangle-path"
                      fill="#FAB908"
                      transform="translate(17.341993, 31.386345) rotate(180.000000) translate(-17.341993, -31.386345) "
                      points="15.1742442 30.2019545 19.5097426 30.2019545 19.5097426 32.5707352 15.1742442 32.5707352"
                    />
                    <ellipse
                      id="Oval"
                      fill="#34A853"
                      cx="25.0276498"
                      cy="25.6617916"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <ellipse
                      id="Oval"
                      fill="#34A853"
                      cx="25.0276498"
                      cy="17.9632541"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <rect
                      id="Rectangle-path"
                      fill="#34A853"
                      transform="translate(25.027649, 21.812522) rotate(180.000000) translate(-25.027649, -21.812522) "
                      x="22.8598999"
                      y="17.9632533"
                      width="4.3354984"
                      height="7.69853747"
                    />
                    <ellipse
                      id="Oval"
                      fill="#FAB908"
                      cx="17.3419936"
                      cy="11.0543102"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                    <ellipse
                      id="Oval"
                      fill="#FAB908"
                      cx="17.3419936"
                      cy="23.6878076"
                      rx="2.1677492"
                      ry="2.17138237"
                    />
                  </g>
                </g>
                <g
                  id="Group-4"
                  filter="url(#filter-17)"
                  transform="translate(257.912000, 177.454918)"
                >
                  <g id="Group-3" fill="#FC7E0F">
                    <path
                      d="M0,20.0655738 C0,31.1476858 8.96903664,40.1311475 20.0326061,40.1311475 C31.0955694,40.1311475 40.064,31.1476858 40.064,20.0655738 C40.064,8.98346173 31.0955694,0 20.0326061,0 C8.96903664,0 0,8.98346173 0,20.0655738 Z"
                      id="Stroke-37"
                    />
                  </g>
                  <g
                    id="logo-(2)"
                    transform="translate(9.014400, 9.029508)"
                    fill="#FFFFFF"
                  >
                    <path
                      d="M11.0176,22.0721311 C4.91192152,22.0721311 0,17.1519772 0,11.0360656 C0,4.92015393 4.91192152,0 11.0176,0 C17.1232785,0 22.0352,4.92015393 22.0352,11.0360656 C22.0352,17.1519772 17.1232785,22.0721311 11.0176,22.0721311 Z M11.0176,17.7037805 L11.84392,16.8760756 L11.0176,13.7032067 L10.19128,16.8760756 L11.0176,17.7037805 Z M9.96183848,17.6577049 L9.54867848,19.2212395 L10.5127185,18.2555838 L9.96183848,17.6577049 Z M12.0733615,17.6577049 L11.5224815,18.2095082 L12.4865215,19.1751639 L12.0733615,17.6577049 Z M12.8539585,20.5085966 L11.0176,18.6694362 L9.18124152,20.5085966 C9.77812,20.6007477 10.3749985,20.692623 11.0176,20.692623 C11.6602015,20.692623 12.25708,20.6465474 12.8539585,20.5085966 Z M11.0176,1.3795082 C5.69251848,1.3795082 1.3772,5.70205918 1.3772,11.0360656 C1.3772,15.2664654 4.08560152,18.8531867 7.85004,20.1408197 L9.91584,12.4616493 C9.45668152,12.1396721 9.18124152,11.5878689 9.18124152,10.98999 C9.18124152,9.97853459 10.0075615,9.15082967 11.0176,9.15082967 C12.0276385,9.15082967 12.8539585,9.97853459 12.8539585,10.98999 C12.8539585,11.5878689 12.5785185,12.0935966 12.11936,12.4616493 L14.18516,20.1408197 C17.9495985,18.8531867 20.658,15.2664654 20.658,11.0360656 C20.658,5.70205918 16.3426815,1.3795082 11.0176,1.3795082 Z M17.3067215,15.8182687 C17.07728,16.0941703 16.66412,16.1863215 16.3426815,15.9562195 C16.0215185,15.7263934 15.97552,15.312541 16.2049615,15.0366393 C16.2049615,15.0366393 17.4444415,13.3812295 17.4444415,11.0360656 C17.4444415,8.69090164 16.2049615,7.0354918 16.2049615,7.0354918 C15.97552,6.75959016 16.0215185,6.3457377 16.3426815,6.11591164 C16.66412,5.88580967 17.07728,5.97796082 17.3067215,6.25386246 C17.3987185,6.3457377 18.8216415,8.23097361 18.8216415,11.0360656 C18.8216415,13.8411575 17.3987185,15.7263934 17.3067215,15.8182687 Z M13.9557185,14.024908 C13.6802785,13.7490064 13.7260015,13.2432787 14.0014415,12.967377 C14.0014415,12.967377 14.6900415,12.2315474 14.6900415,11.0360656 C14.6900415,9.84058377 14.0014415,9.15082967 14.0014415,9.1047541 C13.7260015,8.82885246 13.7260015,8.36892443 13.9557185,8.04722311 C14.2311585,7.7252459 14.6443185,7.7252459 14.9197585,8.00114754 C14.9654815,8.04722311 16.0672415,9.19662934 16.0672415,11.0360656 C16.0672415,12.8755018 14.9654815,14.024908 14.9197585,14.0709836 C14.6443185,14.3468852 14.2311585,14.3008097 13.9557185,14.024908 Z M8.07948152,14.024908 C7.80404152,14.3008097 7.39088152,14.3468852 7.11544152,14.0709836 C7.06971848,13.9791084 5.96795848,12.8755018 5.96795848,11.0360656 C5.96795848,9.19662934 7.06971848,8.09302279 7.11544152,8.00114754 C7.39088152,7.7252459 7.85004,7.7252459 8.07948152,8.04722311 C8.35492152,8.32312475 8.30919848,8.82885246 8.03375848,9.1047541 C8.03375848,9.15082967 7.34515848,9.84058377 7.34515848,11.0360656 C7.34515848,12.2315474 8.03375848,12.967377 8.03375848,12.967377 C8.30919848,13.2432787 8.35492152,13.7032067 8.07948152,14.024908 Z M5.69251848,15.9562195 C5.37108,16.1863215 4.95792,16.0941703 4.72847848,15.8182687 C4.63648152,15.7263934 3.21355848,13.8411575 3.21355848,11.0360656 C3.21355848,8.23097361 4.63648152,6.3457377 4.72847848,6.25386246 C4.95792,5.97796082 5.37108,5.88580967 5.69251848,6.11591164 C6.01368152,6.3457377 6.05968,6.75959016 5.83023848,7.0354918 C5.83023848,7.0354918 4.59075848,8.69090164 4.59075848,11.0360656 C4.59075848,13.3812295 5.83023848,15.0366393 5.83023848,15.0366393 C6.05968,15.312541 5.96795848,15.7263934 5.69251848,15.9562195 Z"
                      id="overcastCanvas-bezier"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export { DistributionSvg };
